import React, { useState, useEffect } from 'react'
import { Button } from 'antd'
import { useNavigate,useParams } from 'react-router-dom'
import axios from 'axios'
import { AssesmentUrl,BaseUrl } from '../../../Constants/Constants'
import { useStateValue } from '../../../../Reducer/reducer'
import ReviewAnswerModuleTraining from './ReviewAnswerModule/ReviewAnswerModuleTraining'
import FeedbackModal from '../../../Feedback/FeedbackModal'

const TrainingMcqResult = () => {

  const navigate = useNavigate()
  const { id, assessmentId } = useParams();
  const [
    { UserID ,eligibility }
] = useStateValue();
const localEligibility = localStorage.getItem("eligibility");
const [Score, setScore] = useState('')
const [Data, setData] = useState('')
const [showFeedbackModal, setShowFeedbackModal] = useState(false)
const [feedbackAvailable, setFeedbackAvailable] = useState(null)
 
useEffect(()=>{

  console.log(eligibility, UserID, localEligibility,"eligibility");
},[])

useEffect(() => {
  let body = {
    assessment_id: assessmentId
  }
  axios
      .post(`${BaseUrl}assesment/Assesment_details`,body, { withCredentials: true })
      .then((res) => {
          setData(res.data.data)
          console.log(res.data.data ,"len")
      })
      .catch((err) => {
      })
      .finally((res) => {

      })
}, [])

// Prefetch feedback forms on results page load
useEffect(() => {
  if (!id) return;
  axios.post(`${BaseUrl}feedback-form/list_of_feedback_forms`, { course_id: id }, { withCredentials: true })
    .then(res => {
      const list = Array.isArray(res?.data?.data) ? res.data.data : [];
      setFeedbackAvailable(list.length > 0);
    })
    .catch(() => setFeedbackAvailable(false));
}, [id])
useEffect(() => {
  const blockBackNavigation = () => {
    window.history.pushState(null, '', window.location.href);
  };

  // Push initial state
  blockBackNavigation();

  // On back attempt, push the state again
  const handlePopState = () => {
    blockBackNavigation();
    alert("Back navigation is disabled during the assessment!");
  };

  window.addEventListener('popstate', handlePopState);

  return () => {
    window.removeEventListener('popstate', handlePopState);
  };
}, []);




  useEffect(() => {
    let body = {
      user_id: UserID,
      training_id: id,
      assessment_id : assessmentId
    }
    axios
      .post(`${AssesmentUrl}assessment_score_training`, body)
      .then((res) => {
        console.log(res.data.scores[0], 'res');
        const score = res.data.scores[0]?.score; 
        if (score !== undefined) {
          setScore(score);
          console.log(score, 'score');
        }
      })
      .catch((err) => {
        console.log(err)
      })

  }, [])

  const handleDashboard = () => {
    if (feedbackAvailable) {
      setShowFeedbackModal(true)
    } else {
      navigate(`/`)
    }
  }

  const handleFeedbackSuccess = () => {
    setShowFeedbackModal(false)
    navigate(`/`)
  }
  return (
    <div>
    <div className='mcq-res-MainDiv'>
      <div>

        <h1 className='Thanks'>
          Thank You
        </h1>
        <p className='completed'>
          Test Completed sucessfully
        </p>

        <h2 className='completed' >
          Your Score : {Score}
        </h2>
        <Button className='BackToDashboard'
          type='primary' onClick={handleDashboard}
        >
          Continue to Dashboard
        </Button>

      </div>

    </div>

     {eligibility || localEligibility == 'You are eligible' ?
    <ReviewAnswerModuleTraining />: ""}
    
    <FeedbackModal 
      visible={showFeedbackModal}
      courseId={id}
      userId={UserID}
      onSuccessRedirect={handleFeedbackSuccess}
    />
    </div>
  )
}

export default TrainingMcqResult